module.exports = __webpack_public_path__ + "img/project-4.c403be4a.jpg";